(function () {
  // Loaded once per page via snippets/ritual-reveal-script.liquid.
  if (window.__ritualRevealInit) return;
  window.__ritualRevealInit = true;

  var io = null;

  function observe() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
  // Theme editor: re-observe sections that get re-rendered.
  document.addEventListener('shopify:section:load', observe);
})();
